import {
  Grid,
  Form,
  notification,
  Drawer,
  Input,
  Select,
  Space,
  Icons,
  Checkbox,
  Button,
} from '@pankod/refine-antd';
import { useState } from 'react';

interface AddTemplateAttributeDrawerProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: any) => Promise<void>;
}

export const AddTemplateAttributeDrawer: React.FC<AddTemplateAttributeDrawerProps> = ({
  visible,
  onClose,
  onSubmit,
}) => {
  const [isDropdownType, setIsDropdownType] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const breakpoint = Grid.useBreakpoint();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    setIsLoading(true);
    try {
      let data = { ...values };
      if (values.type === 'Text' || values.type === 'Number') {
        data = { ...data, allowCustomValue: true };
      }

      await onSubmit(data);
      onClose();
      form.resetFields();
    } catch (err: any) {
      console.error(err.message);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    }
    setIsLoading(false);
  };

  return (
    <Drawer
      title="Add a new attribute"
      placement="right"
      width={breakpoint.sm ? '450px' : '100%'}
      visible={visible}
      onClose={onClose}
    >
      <Form
        layout="vertical"
        initialValues={{
          required: false,
          allowCustomValue: false,
          options: [],
        }}
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "attribute 'name' missing" }]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true, message: "attribute 'type' missing" }]}
          initialValue={'Text'}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(value) => {
              if (value === 'Dropdown') {
                return setIsDropdownType(true);
              }
              setIsDropdownType(false);
            }}
          >
            <Select.Option key={0} value="Text">
              <Space align="center">
                <Icons.FileTextOutlined /> Text
              </Space>
            </Select.Option>
            <Select.Option key={1} value="Float">
              <Space align="center">
                <Icons.NumberOutlined /> Number
              </Space>
            </Select.Option>
            <Select.Option key={2} value="Boolean">
              <Space align="center">
                <Icons.CheckCircleOutlined /> Boolean
              </Space>
            </Select.Option>
            <Select.Option key={3} value="Dropdown">
              <Space align="center">
                <Icons.UnorderedListOutlined /> Dropdown
              </Space>
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Options" name="options" hidden={!isDropdownType}>
          <Select mode="tags" placeholder="options" style={{ width: '100%' }} />
        </Form.Item>

        <Space>
          <Form.Item name="required" valuePropName="checked">
            <Checkbox>Required</Checkbox>
          </Form.Item>
          <Form.Item name="allowCustomValue" valuePropName="checked" hidden={!isDropdownType}>
            <Checkbox>Custom value</Checkbox>
          </Form.Item>
        </Space>

        <Form.Item wrapperCol={{ span: 4, offset: 20 }}>
          <Button type="primary" htmlType="submit" disabled={isLoading}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};
